import merge from 'deepmerge'
import Actions from '../actions'
import Utils from '../../common/Utils'

// NOTE: gameState contains move history 
//  you can use that for animation
const defaultState = {
  gameState: null,
  isSubmitting: false,
  submittedPlayers: {},
}

/*
{
  '_id': None,
  'game_type': None,
  'users': [], # user_id: True 
  'meta_data': {}, # name etc
  'init_state': {},
  'current_state': {},
  'phase': {}, #goes into state?
  'state_change_history': [], # list of partial object masks
  'move_history': [], # list of moves by phase -> user that resulted in the state changes
  'current_move': {}, # moves by user for the current phase
}
*/

function setGameState (state, gameState) {
  let submittedPlayers = Utils.clone(defaultState.submittedPlayers)
  for (const playerId in gameState.current_move) {
    submittedPlayers[playerId] = true
  }
  return { ...defaultState,
    gameState: gameState,
    submittedPlayers,
  }
}

function setIsSubmitting (state, isSubmitting) {
  return { ...state,
    isSubmitting: isSubmitting,
  }
}

function updateGame (state, gameUpdate) {
  // TODO? make update game and update phase seperate calls? 
  // TODO? check if the phase coming in on the state change 
  //  is the same as the one here in state to make sure we are in sync?
  // are we prematurly optomising for:
  //  - partial state updates
  //  - out of sync (server should know if an update failed / client should know if they lost contact)
  //    in either case a state refresh should occur 
  if (!state.gameState || state.gameState._id != gameUpdate.game_id) return state
  let newGameState = Utils.clone(state.gameState)
  newGameState.current_state = merge(newGameState.current_state, gameUpdate.state_change)
  newGameState.state_change_history.push(gameUpdate.state_change)
  newGameState.phase = gameUpdate.phase
  newGameState.move_history.push(gameUpdate.move)
  return { ...state, 
    gameState: newGameState,
    submittedPlayers: Utils.clone(defaultState.submittedPlayers),
  }
}

function setFinal (state, gameUpdate) {
  if (!state.gameState || state.gameState._id != gameUpdate.game_id) return state
  return { ...state, 
    gameState: { ...state.gameState,
      final: gameUpdate.final,
    }
  }
}

function addSubmitedPlayer (state, submition) {
  if (!state.gameState || state.gameState._id != submition.game_id) return state
  let submittedPlayers = Utils.clone(state.submittedPlayers)
  submittedPlayers[submition.user] = submition.has_moved
  return { ...state, 
    submittedPlayers,
  }
}


function gameReducer (state = defaultState, action) {
  switch (action.type) {
    case Actions.GAME_SET_GAME:
      return setGameState(state, action.payload)
    case Actions.GAME_SET_IS_SUBMITTING:
      return setIsSubmitting(state, action.payload)
    case Actions.GAME_UPDATE:
      return updateGame(state, action.payload)
    case Actions.GAME_SET_FINAL:
      return setFinal(state, action.payload)
    case Actions.GAME_ADD_SUBMITTED_PLAYER:
      return addSubmitedPlayer(state, action.payload)

    default:
      return state
  }
}

export default gameReducer
